import type { GraphNode } from '../graph/nodeDefs.js';

export interface PanState {
  x: number;
  y: number;
  scale: number;
}

export const pan: PanState = { x: 0, y: 0, scale: 1 };

export function resetPan(): void {
  pan.x = 0;
  pan.y = 0;
  pan.scale = 1;
}

export function applyTransform(): void {
  const wrapper = document.getElementById('graph-canvas-wrapper') as HTMLElement | null;
  if (wrapper) {
    wrapper.style.transform = `translate(${pan.x}px, ${pan.y}px) scale(${pan.scale})`;
  }
}

export interface DraggingNodeState {
  node: GraphNode;
  startX: number;
  startY: number;
  origX: number;
  origY: number;
  moved: boolean;
}

export const interactionState: { draggingNode: DraggingNodeState | null } = {
  draggingNode: null
};
